import type { CertificateTemplateOption } from '~/gql/certificates/certificates'
import { useTranslation } from 'react-i18next'

type Props = {
  /** Modèle choisi ; '' = celui par défaut de l'organisation. */
  value: string
  onChange: (templateId: string) => void
  templates: CertificateTemplateOption[]
}

/**
 * Le modèle d'attestation du parcours (#162). « Par défaut » suit le modèle par
 * défaut de l'organisation, même s'il change ensuite.
 */
function CertificateTemplateField({ value, onChange, templates }: Props) {
  const { t } = useTranslation()
  const fallback = templates.find(template => template.isDefault)

  return (
    <div className="flex flex-col gap-1.5 sm:col-span-2">
      <label className="text-sm font-medium" htmlFor="session-certificate-template">{t('sessions.certificateTemplate.label')}</label>
      <select
        id="session-certificate-template"
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-describedby="session-certificate-template-hint"
        className="h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm"
      >
        <option value="">
          {fallback ? t('sessions.certificateTemplate.defaultNamed', { name: fallback.name }) : t('sessions.certificateTemplate.default')}
        </option>
        {templates.map(template => (
          <option key={template.id} value={template.id}>{template.name}</option>
        ))}
      </select>
      <p id="session-certificate-template-hint" className="text-xs text-muted-foreground">{t('sessions.certificateTemplate.hint')}</p>
    </div>
  )
}

export default CertificateTemplateField
